import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mb-40" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "form-group mb-25" }
const _hoisted_4 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2" }
const _hoisted_5 = { class: "d-block fs-14 text-black mb-0" }
const _hoisted_6 = { class: "reference-input-wrap" }
const _hoisted_7 = ["placeholder", "value"]
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-25" }
const _hoisted_10 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-25" }
const _hoisted_14 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { value: "" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-25" }
const _hoisted_20 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_21 = { class: "reference-input-wrap" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { value: "" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group mb-25" }
const _hoisted_27 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group mb-25" }
const _hoisted_31 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { value: "1" }
const _hoisted_34 = { value: "0" }
const _hoisted_35 = { class: "col-lg-12" }
const _hoisted_36 = { class: "form-group mb-25" }
const _hoisted_37 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_38 = ["placeholder", "value"]
const _hoisted_39 = { class: "col-12 text-end" }
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t("income_page.reference_no")) + " ", 1),
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("input", {
            type: "text",
            class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white",
            placeholder: _ctx.$t('income_page.reference_no'),
            value: _ctx.referenceno,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:referenceno', ($event.target as HTMLInputElement).value)))
          }, null, 40, _hoisted_7),
          (!_ctx.isEditMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn style-two generate-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('generate-reference')))
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("income_page.generate")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("income_page.date")), 1),
        _createElementVNode("input", {
          type: "datetime-local",
          class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white",
          value: _ctx.date,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:date', ($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_11)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("label", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.$t("income_page.warehouse")) + " ", 1),
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
        ]),
        _createElementVNode("select", {
          class: "bg-white border-0 rounded-1 fs-14 text-optional",
          value: _ctx.form.warehouse_id,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:field', 'warehouse_id', ($event.target as HTMLSelectElement).value)))
        }, [
          _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t("income_page.select_warehouse")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
            return (_openBlock(), _createElementBlock("option", {
              key: warehouse.id,
              value: warehouse.id
            }, _toDisplayString(warehouse.name), 9, _hoisted_17))
          }), 128))
        ], 40, _hoisted_15)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("income_page.income_category")), 1),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("select", {
            class: "bg-white border-0 rounded-1 fs-14 text-optional category-select",
            value: _ctx.form.category_id,
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:field', 'category_id', ($event.target as HTMLSelectElement).value)))
          }, [
            _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t("income_page.select_category")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
              return (_openBlock(), _createElementBlock("option", {
                key: category.id,
                value: category.id
              }, _toDisplayString(category.name), 9, _hoisted_24))
            }), 128))
          ], 40, _hoisted_22),
          _createElementVNode("button", {
            type: "button",
            class: "btn style-two generate-btn",
            "data-bs-toggle": "modal",
            "data-bs-target": "#incomeCategoryModal",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('open-category-modal')))
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("income_page.add_category")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("income_page.amount")), 1),
        _createElementVNode("input", {
          type: "number",
          class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
          placeholder: "0",
          value: _ctx.form.amount,
          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:field', 'amount', ($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_28),
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center fw-semibold text-optional" }, "$", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("income_page.status")), 1),
        _createElementVNode("select", {
          class: "bg-white border-0 rounded-1 fs-14 text-optional",
          value: _ctx.form.status,
          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:field', 'status', ($event.target as HTMLSelectElement).value)))
        }, [
          _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.$t("income_page.active")), 1),
          _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.$t("income_page.inactive")), 1)
        ], 40, _hoisted_32)
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("income_page.details")), 1),
        _createElementVNode("textarea", {
          cols: "30",
          rows: "10",
          placeholder: _ctx.$t('income_page.details_placeholder'),
          class: "d-block w-100 bg-white border-0 rounded-1 resize-none fs-14 text-title",
          value: _ctx.form.description,
          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:field', 'description', ($event.target as HTMLTextAreaElement).value)))
        }, null, 40, _hoisted_38)
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("button", {
        class: "btn style-one transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16",
        type: "button",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('submit'))),
        disabled: _ctx.isLoading
      }, _toDisplayString(_ctx.isLoading ? (_ctx.isEditMode ? _ctx.$t('income_page.updating') : _ctx.$t('income_page.creating')) : (_ctx.isEditMode ? _ctx.$t('income_page.update_income') : _ctx.$t('create_income'))), 9, _hoisted_40)
    ])
  ]))
}